import React, { useState } from "react";
import { observer } from "mobx-react-lite";
import { Srstyledtabs } from "../sr-styles";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import { SrPersonalInfo } from "./sr-personal-info";
import { SrRequestServiceInfo } from "./sr-request-service-info";
import FullScreenImage from "../../../components-new/FullscreenImage";
import { useStore } from "../../../helpers";
import { IconButton, Tooltip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useQueryClient } from "@tanstack/react-query";
import { SatisfactionIcon } from "../sr-components/satisfaction-icon";
import { ENABLE_SAT_COLUMN } from "../sr-constants";

const Tabs = ["Personal Information", "Request & Related Information"];

export const SrRequestView = observer(() => {
  const [currentTabValue, setCurrentTabValue] = useState(Tabs[0]);
  const rootStore = useStore();
  const { userStore, serviceRequestsStore } = rootStore;
  const navigate = useNavigate();

  const queryClient = useQueryClient();
  const activeRequest = serviceRequestsStore.activeServiceRequest;

  if (!activeRequest || !activeRequest.subject) {
    return (
      <div className="p-4 text-gray-500 text-center italic">
        No service request selected or data unavailable.
      </div>
    );
  }

  const handledelete = () => {
    serviceRequestsStore.update_modal_status("deleteServiceRequest", true);
    serviceRequestsStore.setshowServiceRequest(false);
    queryClient.invalidateQueries(["sr-list"]);
  };

  return (
    <div className="flex flex-col">
      <div className="flex flex-row items-center justify-between mb-3">
        <div className="flex-grow mr-3">
          <TabContext value={currentTabValue}>
            <Srstyledtabs
              // @ts-ignore
              indicatorColor={"common.black"}
              variant={"fullWidth"}
              onChange={(e, value) => setCurrentTabValue(value)}
            >
              {Tabs.map((tab) => (
                <Tab key={tab} label={tab} value={tab} />
              ))}
            </Srstyledtabs>
          </TabContext>
        </div>

        <div className="flex gap-2 items-center">
          {ENABLE_SAT_COLUMN && activeRequest?.id && (
            <div className="mr-2">
              <SatisfactionIcon requestId={activeRequest.id} size="medium" />
            </div>
          )}
          <Tooltip title="Edit">
            <IconButton
              size="small"
              disableRipple
              onClick={(e) => {
                e.stopPropagation();
                navigate("editrequest");
                serviceRequestsStore.setActiveServiceRequest(activeRequest);
                serviceRequestsStore.setshowServiceRequest(false);
              }}
            >
              <i className="fas fa-edit" />
            </IconButton>
          </Tooltip>

          <Tooltip title="Delete">
            <IconButton size="small" disableRipple onClick={handledelete}>
              <i className="fas fa-trash" />
            </IconButton>
          </Tooltip>
        </div>
      </div>

      <div>
        <TabContext value={currentTabValue}>
          <TabPanel value={Tabs[0]}>
            <SrPersonalInfo />
          </TabPanel>
          <TabPanel value={Tabs[1]}>
            <SrRequestServiceInfo />
          </TabPanel>
        </TabContext>

        <FullScreenImage
          s3Key={userStore.attachment_image?.s3Key}
          width={1080}
          height={960}
        />
      </div>
    </div>
  );
});
